module.exports = __webpack_public_path__ + "img/orly-schema.8feb8d52.jpg";